import React from 'react';
import { sleepList } from './OnboardingConstants';

function OnboardingBarChart({ data = [], height = 248, yAxelText = '', showCursor = true, showMash = true, showText = true, showTextValue = true, list = sleepList, loading = false }) {
	const allValues = data?.map((e: any) => e?.value ?? 0);
	const maxValue = Math.ceil(Math.max(...allValues, 1));
	const horizontalLines = Array(Math.min(10, maxValue + 1))?.fill('1');

	return (
		<div style={{ width: '100%', paddingLeft: showText ? 70 : 0, position: 'relative' }}>
			{showText && (
				<p className='absolute left-0 bottom-0 rotate-180 text-center text-[#9392ad] pt-[70px] pb-[20px]' style={{ writingMode: 'vertical-rl' }}>
					{yAxelText}
				</p>
			)}
			<div style={{ position: 'relative', height, borderWidth: showMash ? 1 : 0, borderBottomWidth: 1, width: '100%', border: '1px solid #ecebf8' }}>
				{showMash && (
					<>
						<div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
							{data?.map((item, index) => (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'flex-end',
										width: !!data?.length ? `${(1 / data?.length) * 100}%` : '11.11%',
									}}
									key={index}
								>
									<div style={{ height, width: 1, backgroundColor: '#ECEBF8' }}></div>
								</div>
							))}
						</div>
						<div style={{ position: 'absolute', top: 0, left: 0, zIndex: 2 }}>
							{horizontalLines?.map((item, index) => (
								<div className='' style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'flex-end', height: (1 / Math.min(10, maxValue + 1)) * height }} key={index}>
									<div style={{ height: 1, width: '100%', backgroundColor: '#ECEBF8' }}></div>
								</div>
							))}
						</div>
					</>
				)}
				<div style={{ position: 'absolute', top: 0, left: 0, zIndex: 3, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
					{loading ? (
						<BarChartSkeleton height={height} />
					) : (
						data?.map((item: any, index: number) => {
							return (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'flex-end',
										width: !!data?.length ? `${(1 / data?.length) * 100}%` : '11.11%',
										height,
									}}
									key={index}
								>
									<div className='flex flex-row items-center justify-center pb-[5px]'>
										<p>{item.value}</p>
									</div>
									<div
										title={showTextValue && !!list[item.label - 1] ? list[item.label - 1]?.name : item.label}
										onClick={() => {
											if (item.value == 0) return;
										}}
										style={{
											height: (height * item.value) / (maxValue + 1),
											width: '85%',
											borderTopRightRadius: 6,
											borderTopLeftRadius: 6,
											background: '#CAE5FF',
											border: `3px solid #CAE5FF`,
											cursor: showCursor ? 'pointer' : 'default',
										}}
									></div>
								</div>
							);
						})
					)}
				</div>
			</div>
			<div className='flex flex-row items-center w-full' style={{ marginTop: 9, display: 'flex', flexDirection: 'row', flex: 1 }}>
				{data?.map((item: any, index: number) => {
					return (
						<div title={showTextValue && !!list[item.label - 1] ? list[item.label - 1]?.name : item.label} className={showCursor ? 'pointer' : ''} key={index} style={{ flex: 1, overflow: 'hidden' }}>
							<div className='text-center text-[14px] leading-4 text-darkenPurple capitalize px-2' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								{showTextValue && !!list[item.label - 1] ? list[item.label - 1]?.name : item.label}
							</div>
							{/* {showEmotions && (
                                <div className="items-center justify-center flex mt-[5px]" style={{ opacity: showCursor ? opacity : 1 }}>
                                    <img src={emotions_heads[item.label]} alt="emotion" width={emotionSize} height={emotionSize} className="self-center" />
                                </div>
                            )} */}
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default OnboardingBarChart;

const BarChartSkeleton = ({ height }: { height: number }) => {
	return (
		<>
			{Array.from({ length: 6 }).map((_, index) => (
				<div
					key={index}
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'flex-end',
						width: `${100 / 6}%`,
						height,
					}}
				>
					<div className='flex flex-row items-center justify-center pb-[5px]'>
						<div className='bg-lightBG animate-pulse h-4 w-6 rounded'></div>
					</div>
					<div
						style={{
							height: Math.random() * height * 0.8 + 20,
							width: '85%',
							borderRadius: 6,
						}}
						className='bg-lightBG animate-pulse'
					></div>
				</div>
			))}
		</>
	);
};
